import { render } from "./ContentTag.vue?vue&type=template&id=22e28abb"
import script from "./ContentTag.vue?vue&type=script&lang=js"
export * from "./ContentTag.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__